<template>
  <div class="assignment-card md-elevation-3">
    <div class="card-body">
      <div class="card-body-upper">
        <a class="assignment-name" @click="select()">{{ assignment.name }}</a>
        <div>
          <span>{{ assignment.attemptsCount }}</span>
          <span class="gray-2 color"> Attempts per user</span>          
        </div>
        <div v-if="status === 'PENDING'">
          <div>
            <span class="gray-2 color">Start Date</span> 
            <span> {{ assignment.startTime | formatDate }}</span>
          </div>
          <div>
            <span class="gray-2 color">Start Time</span>
            <span> {{ assignment.startTime | formatTime }}</span>
          </div>
        </div>
        <div v-if="status === 'IN_PROGRESS'">
          <div>
            <span class="gray-2 color">End Date</span> 
            <span> {{ assignment.endTime | formatDate }}</span>
          </div>
          <div>
            <span class="gray-2 color">End Time</span>
            <span> {{ assignment.endTime | formatTime }}</span>
          </div>
        </div>
      </div>
      <div v-if="status !== 'PENDING' && assignment.percentComplete !== undefined">
        <span :style="{'color': progressColor}">{{ assignment.percentComplete }}%</span>
        <span class="gray-2 color"> Complete</span>
      </div>
    </div>
    <md-menu md-direction="bottom-start">
      <md-button md-menu-trigger class="md-icon-button md-dense">
        <md-icon>more_vert</md-icon>
      </md-button>
    
      <md-menu-content>
        <md-menu-item v-if="status === 'PENDING'" @click="startTask()">Start Task</md-menu-item>
        <md-menu-item v-if="status === 'PENDING'" @click="deleteTask()">Delete Task</md-menu-item>
        <md-menu-item v-if="status === 'IN_PROGRESS'" @click="completeTask()">Complete Task</md-menu-item>
        <md-menu-item v-if="status === 'IN_PROGRESS'" @click="deleteInProgress()">Delete Task</md-menu-item>
        <md-menu-item v-if="status === 'COMPLETE'" @click="removeTask()">Remove Task</md-menu-item>
      </md-menu-content>
    </md-menu>
  </div>
</template>

<script>
export default {
  name: 'assignment-card',
  props: {
    assignment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    status() {
      const now = new Date().toJSON();
      if (this.assignment.startTime > now) {
        return 'PENDING';
      } else if (this.assignment.startTime <= now && this.assignment.endTime >= now) {
        return 'IN_PROGRESS';
      } else if (this.assignment.endTime < now && this.assignment.status !== 'REMOVED') {
        return 'COMPLETE';
      }
      return 'INVALID';
    },
    progressColor() {
      if (this.assignment.percentComplete === 100) {
        return '#62cd63';
      } else if (this.assignment.percentComplete > 0) {
        return '#ffB904';
      }
      return 'black';
    },
  },
  methods: {
    select() {
      this.$emit('selected');
    },
    startTask() {
      this.$emit('startTask', this.assignment);
    },
    deleteTask() {
      this.$emit('deleteTask', this.assignment);
    },
    completeTask() {
      this.$emit('completeTask', this.assignment);
    },
    removeTask() {
      this.$emit('removeTask', this.assignment);
    },
    deleteInProgress() {
      this.$emit('deleteInProgress', this.assignment);
    },
  },
};
</script>

<style scoped>
.assignment-card {
  background-color: white;
  border-radius: 5px;
  min-height: 200px;
  display: flex;
  justify-content: space-between;
  padding-top: 6px;
  padding-left: 6px;
}

.assignment-card:not(:last-child) {
  margin-bottom: 20px;  
}

.card-body {
  padding: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 1.4rem;
}

.card-body-upper {
  display: block;
}

.assignment-name {
  font-size: 16px;
  text-decoration: underline;
  cursor: pointer;
}

.md-button .md-icon {
  transform: rotate(90deg);
}

</style>